import React from 'react';
import { Button } from 'antd';
import {
    ArrowRightOutlined,
    CommentOutlined,
    UsergroupAddOutlined,
    ApiOutlined,
} from '@ant-design/icons';
import { get } from '../../utils/request';
import './index.scss';
import Footer from '../footer';
import bgimage from '../../assets/images/home_pic_banner.png'

export default class HomeContent extends React.PureComponent {

    state = {
        toolsCount: null,
        businessCount: null,
        activityCount: null,
        rankList: {
        },
        appCount: 20,
        appList: [{name:'美团外卖', icon:'https://p0.meituan.net/travelcube/d67b3ef16e5f0e1d811163cdb6cb04af53513.png@150w_80q'},
            {name:'美团', icon:'https://msstest-corp.sankuai.com/v1/mss_5CX3D9i6ZE2y9E3UFB4Mvw==/gray-help/meituan.png'},
            {name:'大众点评',icon: 'http://p0.meituan.net/appinfo/c3566a5975d114aaf4b90865057b7f265677.png'},
            {name:'美团买菜', icon: 'https://msstest-corp.sankuai.com/v1/mss_5CX3D9i6ZE2y9E3UFB4Mvw==/gray-help/icon60@2x.png'},
            {name:'美团买药医生端',icon: 'http://s3plus.vip.sankuai.com/v1/mss_01eecd01936241e6a4168bd70352694f/hpx-misc/fe608cb78f824b38eb9cff12817f58b0'},
            // {name:'外卖出海', icon: 'http://s3plus.vip.sankuai.com/v1/mss_01eecd01936241e6a4168bd70352694f/hpx-misc/7f222bb53fc56a8251539f7944f7775f'},
            {name:'美团酒店', icon: 'http://p1.meituan.net/appinfo/0e954e270dbd63df6727dcc5d4bcd3b515737.png'}
        ],
    }

    componentDidMount = async () => {

        const rank = await get('/tool/tool/rank', {}) || {};
        let array = rank.tools;

        if (array && array.length > 0) {

            let count = array.length;
            let firstRankTool = array[0];
            let secondRankTool;
            let thirdRankTool;
            if (count > 1) {
                secondRankTool = array[1];
            }
            if (count > 2) {
                thirdRankTool = array[2];
            }
            this.setState({...this.state, rankList:{
                firstRankTool,
                secondRankTool,
                thirdRankTool,
            }});
        }

        const res = await get('/tool/home', {}) || {};
        const { toolsCount, businessCount, activityCount } = res;
        this.setState({
            toolsCount,
            businessCount,
            activityCount,
        })
    }

    gotoSearch = () => {
        window.location.href = './kitListPage.html';
    }

    gotoMerlin = () => {
        window.open('https://merlin.sankuai.com/mfepro/merlin/');
    }

    render() {
        const {
            toolsCount,
            appCount,
            activityCount,
            rankList,
            appList,
        } = this.state;
        const {
            firstRankTool,
            secondRankTool,
            thirdRankTool,
        } =rankList;
        return (
            <>
                <div className="content">
                    <img src={bgimage} />
                    <section className="content-info max-width">
                        <div>
                            <h3 style={{ marginTop: '110px' }}>
                                移动研发助手<br />
                            </h3>
                            <p style={{ fontSize: '18px' }}>整合优化公司内现有的工具，建设缺少的工具，建设移动研发助手平台，统一管理研发测试协作过程中的工具，提供工具插件化管理能力，从而提高开发、测试，排查问题、UI产品走查、等效率。</p>
                            <Button type="primary" className="quick-start" onClick={this.gotoSearch} size="large">
                                快速开始
                                <ArrowRightOutlined />
                            </Button>
                        </div>
                    </section>
                </div>


                <div className="content-introduce max-width">
                    <div className="content-count">
                        <h1 className="content-introduce-title">
                            业务数据
                        </h1>
                        <div className="content-introduce-title-line"></div>
                        <section className="max-width">
                            <div className="item">
                                <h3 className="text">接入APP数量</h3>
                                <div className="count">
                                    <UsergroupAddOutlined style={{ fontSize: 48, color: '#9287e7', marginBottom: '8px' }} />
                                    <b>{appCount}</b>
                                </div>
                            </div>
                            <div className="item">
                                <h3 className="text">平台DAU</h3>
                                <div className="count">
                                    <img src={require('../../assets/images/rank_logo_dau.png')} alt="" />
                                    <b>{activityCount}</b>
                                </div>
                            </div>
                            <div className="item">
                                <h3 className="text">工具数量</h3>
                                <div className="count">
                                    <img src={require('../../assets/images/rank_logo_tool.png')} alt="" />
                                    <b>{toolsCount}</b>
                                </div>
                            </div>
                        </section>

                        <section className="max-width app-list">
                            {appList && appList.map((app, index) => (
                                <div key={index} className="app-item">
                                    <img src={app.icon}/>
                                    <div>{app.name}</div>
                                </div>))}
                        </section>

                        <h1 className="content-introduce-title" style={{ marginTop: 50 }}>
                            最受欢迎工具
                        </h1>
                        <div className="content-introduce-title-line"></div>
                        <section className="max-width">
                            <div className="item">
                                <h3 className="text">{firstRankTool ? firstRankTool.toolName : null}</h3>
                                <div className="count">
                                    <img src={require('../../assets/images/rank_logo_first.png')} alt="" />
                                    <b>{firstRankTool ? firstRankTool.count : null}</b>
                                </div>
                            </div>
                            <div className="item">
                                <h3 className="text">{secondRankTool ? secondRankTool.toolName : null}</h3>
                                <div className="count">
                                    <img src={require('../../assets/images/rank_logo_second.png')} alt="" />
                                    <b>{secondRankTool ? secondRankTool.count : null}</b>
                                </div>
                            </div>
                            <div className="item">
                                <h3 className="text">{thirdRankTool ? thirdRankTool.toolName : null}</h3>
                                <div className="count">
                                    <img src={require('../../assets/images/rank_logo_third.png')} alt="" />
                                    <b>{thirdRankTool ? thirdRankTool.count : null}</b>
                                </div>
                            </div>
                        </section>
                    </div>

                    <h1 className="content-introduce-title">
                        移动研发助手提供了哪些能力?
                        </h1>
                    <div className="content-introduce-title-line"></div>
                    <section className="">
                        <div className="mind-img-left">
                            <img src={require('../../assets/images/home_pic_left.png')} alt="" />
                        </div>
                        <div>
                            <h3>
                                工具的整合<br />
                            </h3>
                            <p>统一整合优化现有工具，提供了25+个工具，同时提供了平台化能力，定义了工具接入标准</p>
                        </div>
                    </section>

                    <section className="">
                        <div>
                            <h3>
                                工具个性化面板配置<br />
                            </h3>
                            <p>支持个性化的工具面板配置，配置自己常用工具~</p>
                        </div>
                        <div className="mind-img">
                            <img src={require('../../assets/images/home_pic_right.png')} alt="" />
                        </div>
                    </section>

                    <Footer className="footer"></Footer>
                </div>

            </>
        );
    }
}
